export default "__VITE_ASSET__BDn22Tp3__"